import connectToContext from '@slergberg/react-hoc-connect-to-context'

import PlayerContext from './PlayerContext'
import SeekBar from './SeekBar'

export default connectToContext(PlayerContext, (state) => ({
  disabled:
    state.isDisabled ||
    (!state.deckDisabled && state.deckStatus !== 'success') ||
    (!state.recordingDisabled && state.recordingStatus !== 'success'),
  duration: state.duration,
  onPositionChange: state.setPosition,
  onSeekingPosition: state.setSeekingPosition,
  position: state.position,
}))(SeekBar)
